import {
  Box,
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  Link,
  Stack,
  Typography,
} from "@/common/styles/style";
import { styles } from "./style";
import { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { useAuth } from "@/hooks/useAuth";
import DataInput from "@/atoms/dataInput";
import { Routes } from "@/router/routes";
import TermsOfServiceDialog from "@/organisms/termsOfServiceDialog";
import logo from "@/assets/logo.png";
import ErrorMessage from "@/atoms/errorMessage";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [saveEmail, setSaveEmail] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { setIsAuthenticated } = useAuth();

  useEffect(() => {
    if (location.pathname === Routes.LOGIN) {
      localStorage.removeItem("user");
      localStorage.removeItem("loginTime");
      setIsAuthenticated(false);
    }

    const savedEmail = localStorage.getItem("savedEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setSaveEmail(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, setIsAuthenticated]);

  const handleLogin = async (e: FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
        credentials: "include",
      });

      const data = await response.json();
      if (response.ok) {
        console.log(data.message);
        localStorage.setItem("user", JSON.stringify(data.result));
        localStorage.setItem("loginTime", Date.now().toString());
        navigate(Routes.MACHINE_LIST);

        if (saveEmail) {
          localStorage.setItem("savedEmail", email);
        } else {
          localStorage.removeItem("savedEmail");
        }
      } else {
        console.log(`ログイン失敗: ${data.errorCode}, ${data.message}`);
        setError(data.message);
      }
    } catch (error) {
      console.error("API呼び出しエラー:", error);
      setError("グイン中に問題が発生しました。");
    }
  };

  const handleTogglePassword = () => {
    setShow((prev) => !prev);
  };

  const handlePages = (tab: string) => {
    navigate(tab);
  };

  const handleTermsServiceButton = () => {
    setOpen(!open);
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.imageArea}>
        <img src={logo} />
      </Box>
      <Box sx={styles.loginContainer}>
        <Box sx={styles.loginBox}>
          <Typography variant="h5" align="center" marginBottom={2}>
            ログイン
          </Typography>
          <ErrorMessage error={error} />
          <form onSubmit={handleLogin}>
            <DataInput
              datatype="TextField"
              label="メールアドレス"
              textProps={{
                variant: "outlined",
                sx: styles.mt1,
                value: email,
              }}
              onChange={(e) => setEmail(e)}
            />
            <DataInput
              datatype="TextField"
              label="パスワード"
              textProps={{
                variant: "outlined",
                type: show ? "text" : "password",
                sx: styles.mt1,
                value: password,
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleTogglePassword} edge="end">
                        {show ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
              formControlProps={{
                sx: styles.mt2,
              }}
              onChange={(e) => setPassword(e)}
            />
            <Stack direction="row" sx={styles.saveButton}>
              <Checkbox
                checked={saveEmail}
                onChange={(e) => setSaveEmail(e.target.checked)}
              />
              <Typography>入力を保存する</Typography>
            </Stack>
            <Button
              variant="contained"
              fullWidth
              sx={styles.mt1}
              type="submit"
              size="small"
            >
              <Typography variant="button">ログイン</Typography>
            </Button>
          </form>
          <Stack sx={styles.mt2}>
            <Button
              variant="text"
              fullWidth
              size="small"
              onClick={() => handlePages(Routes.PASSWORD_SEND)}
            >
              <Typography variant="button">パスワードを忘れた方へ</Typography>
            </Button>
            <Button
              variant="text"
              fullWidth
              size="small"
              onClick={() => handlePages(Routes.SIGN_UP)}
            >
              <Typography variant="button">会員登録</Typography>
            </Button>
            <Button
              variant="text"
              fullWidth
              size="small"
              onClick={handleTermsServiceButton}
            >
              <Typography variant="button">利用規約</Typography>
            </Button>
          </Stack>
        </Box>
      </Box>
      <TermsOfServiceDialog open={open} onClose={handleTermsServiceButton} />
      <Box sx={styles.lisence}>
        <Typography variant="body2">
          このシステムは、
          <Link href={Routes.LISENCE} target="_blank" rel="noopener noreferrer">
            オープンソースソフトウェア
          </Link>
          を使用して動作しています。
        </Typography>
      </Box>
    </Box>
  );
}
